/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.NotificationTemplates {
    angular.module("meevo.plugins.notificationTemplates", []);
}